import React from "react";
import PropTypes from "prop-types";
import css from "./ToggleSwitch.module.scss";
import LabelHint from "../LabelHint/LabelHint.jsx";

const ToggleSwitch = ({
  checked,
  onChange,
  label,
  className,
  labelPosition = 'right',
  required = false,
  disabled = false,
  activeLabel,
  inactiveLabel,
  hint,
  ...props
}) => {
  // the root is a <label>, so a click on the hint icon would otherwise toggle the switch
  const handleHintClick = (event) => {
    event.preventDefault();
  };

  const labelContent = (
    <>
      {label}
      {required && <span className={css.required}>*</span>}
      {hint &&
        <span className={css.hint} onClick={handleHintClick}>
          <LabelHint hint={hint} />
        </span>
      }
    </>
  );

  return (
    <label
      className={`${css.toggleSwitchLabel} ${css[labelPosition]} ${disabled ? css.disabled : ''} ${className}`}
    >
      {label && (labelPosition === 'left' || labelPosition === 'top') &&
        <span className={css.label}>{labelContent}</span>
      }
      <span className={css.switchWrapper}>
        <input
          type="checkbox"
          checked={checked}
          onChange={e => !disabled && onChange?.(e.target.checked)}
          disabled={disabled}
          className={css.input}
          {...props}
        />
        <span className={css.slider} />
        {activeLabel && inactiveLabel &&
          <span className={css.stateLabel}>{checked ? activeLabel : inactiveLabel}</span>
        }
      </span>
      {label && labelPosition === 'right' &&
        <span className={css.label}>{labelContent}</span>
      }
    </label>
  );
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['left', 'right', 'top']),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hint: PropTypes.node,
};

export default ToggleSwitch;
